import { Messenger } from '@transferwise/icons';
import PropTypes from 'prop-types';
import React from 'react';
import { isMobile } from 'react-device-detect';

import componentStyles from '../SocialSharing.module.less';

import navigatorDetect from './UserAgentDetection';

const androidChromeRedirect = (market, url) => {
  setTimeout(() => {
    if (!document.webkitHidden) {
      window.open(market);
    }
  }, 1000);

  window.open(url);
};

const androidRedirect = (market, url) => {
  const iframe = document.createElement('iframe');
  iframe.style.border = 'none';
  iframe.style.width = '1px';
  iframe.style.height = '1px';
  const t = setTimeout(() => {
    window.open(market);
  }, 1000);
  iframe.addEventListener('load', () => {
    clearTimeout(t);
  });
  iframe.src = url;
  document.body.append(iframe);
};

const iOSRedirect = (itunes, url) => {
  setTimeout(() => {
    if (!document.webkitHidden) {
      window.open(itunes);
    }
  }, 1000);

  window.open(url);
};

const generateOnClick = (onClickToShare, details) => {
  if (onClickToShare) {
    onClickToShare();
  }

  const mobileRedirect = async () => {
    const url = `fb-messenger://share/?link=${encodeURI(details.url)}`;
    const market = 'market://details?id=com.facebook.orca';
    const itunes = 'https://itunes.apple.com/app/id454638411';

    const userAgent = await navigatorDetect();
    switch (userAgent) {
      case 'AndroidChrome':
        androidChromeRedirect(market, url);
        break;
      case 'Android':
        androidRedirect(market, url);
        break;
      case 'iOS':
        iOSRedirect(itunes, url);
        break;
      default:
        window.open(url);
        break;
    }
  };

  if (isMobile) {
    mobileRedirect();
  } else {
    const url =
      `https://www.facebook.com/dialog/?_path=send&app_id=${details.appId}&` +
      `redirect_uri=${encodeURI(details.redirectURL)}&link=${encodeURI(details.url)}`;
    window.open(url, '_blank');
  }
};

const MessengerShareButton = ({ style, iconStyle, sharingDetails }) => (
  <button // eslint-disable-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    type="button"
    className={`${componentStyles['btn--circle']}`}
    style={style}
    onClick={() => {
      generateOnClick(sharingDetails.onClickToShare, sharingDetails);
    }}
  >
    <Messenger size={iconStyle.size} />
  </button>
);

MessengerShareButton.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  iconStyle: PropTypes.shape({
    size: PropTypes.oneOf([16, 24]),
    className: PropTypes.string,
    title: PropTypes.string,
  }),
  sharingDetails: PropTypes.shape({
    appId: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    redirectURL: PropTypes.string.isRequired,
    onClickToShare: PropTypes.func,
  }).isRequired,
};

MessengerShareButton.defaultProps = {
  style: {},
  iconStyle: {
    size: 24,
    className: '',
    title: '',
  },
};

export default MessengerShareButton;
